<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import A from "../lib/Router/A.svelte";
    import R, {LOADER} from "../lib/requests";
    import {sort} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import ColoredNameControl from "../components/controls/ColoredNameControl.svelte";
    import ProjectEdit from "./ProjectEdit.svelte";
    import UserInitials from "../components/controls/UserInitials.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";

    const pageHeaderControls = [
        {key: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ'},
        {key: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'ΟΝΟΜΑ', sortable: true, sort_way: 'ASC'},
        {key: 'client', title: 'ΠΕΛΑΤΗΣ', sortable: false},
        {key: 'users', title: '', sortable: false},
        {key: '', title: ''},
    ];


    let projects = null;
    let projectId = 0;


    const load = async () => {

        const onSuccess = result => {
            projects = result;
        }

        const onFailure = err => {
        };

        await R.handle(R.project.index, {}, onSuccess, onFailure, LOADER.PAGE);
    };


    const onCreateProject = () => {
        router.go(`/app/project/create`)();
    };

    const onEditProject = (project) => {
        projectId = project.id;
        router.go(`/app/project/edit/${project.id}`)();
    };

    const updateProject = project => {
        let prj = projects.find(x => x.id === project.id);
        if (!prj) {
            projects = [project, ...projects];
        } else {
            prj.name = project.name;
            prj.color = project.color;
            prj.users = project.users;
        }
        projectId = project.id;
    };

    const onDelete = project => {

        const onSuccess = result => {
            projects = projects.filter(x => x.id != result);
            Notifier.showMessage("Το project διαγράφτηκε");
        }

        const onFailure = err => {
        };

        Alert.delete("Διαγραφή", `Να διαγραφεί το project "${project.name}";`, () => {
            R.handle(R.project.delete, project.id, onSuccess, onFailure, LOADER.POPUP);
        });
    }

    const onColumnSort = ({detail: column}) => {
        projects = sort(projects, column.key, column.sort_way === 'DESC');
    };

    load();
</script>

<Route exact>
    <PageHeader title="Projects" controls={ pageHeaderControls } on:create={ onCreateProject } on:reload={ load }/>

    <!--    <div class="panel border-default mb-6">-->
    <!--        <div class="panel-body p-2">-->
    <!--            <div class="row">-->
    <!--                <div class="col-lg-3">-->
    <!--                    <div class="input-group unbox-control">-->
    <!--                        <span class="input-group-text gray-icon"><Icon name="search"/></span>-->
    <!--                        <input type="text" class="form-control" on:keyup="{ onSearchKeyup }"-->
    <!--                               placeholder="email χρήστη"/>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--                <div class="col-lg-9 text-end">-->
    <!--                    <button class="btn btn-primary" on:click="{ load }">ΕΥΡΕΣΗ</button>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </div>-->

    <div class="panel">
        <div class="panel-body">
            <table class="table table-list table-list-border">
                <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                <tbody>
                {#if projects}
                    {#if projects.length}
                        {#each projects as project}
                            <tr class="row-hover" class:row-selected="{ projectId === project.id }">
                                <td>
                                    <button class="btn-reset btn-block is-link"
                                            on:click="{ () => onEditProject(project) }">
                                        <ColoredNameControl name="{ project.name }" color="{ project.color }"/>
                                    </button>
                                </td>
                                <td class="text-gray">
                                    {#if project.client}
                                        {project.client.name}
                                    {/if}
                                </td>
                                <td class="users-column">
                                    <div class="d-flex align-items-center justify-content-end gap-1">
                                        {#if project.users.length > 0}
                                            {#each project.users as item}
                                                <UserInitials user={item} md/>
                                            {/each}
                                        {/if}
                                    </div>
                                </td>
                                <td class="button-column">
                                    <button class="button" title="διαγραφή" on:click="{ () => onDelete(project) }">
                                        <AppIcon icon="trash"/>
                                    </button>
                                </td>
                            </tr>
                        {/each}
                    {:else}
                        <tr>
                            <td class="text-muted" colspan="{ tableColumns.length }">
                                <p>
                                    Δεν υπάρχουν projects
                                </p>
                                <A href="/app/project/create" class="btn btn-primary">ΔΗΜΙΟΥΡΓΙΑ PROJECT</A>
                            </td>
                        </tr>
                    {/if}
                {/if}
                </tbody>
            </table>
        </div>
    </div>
</Route>


<Route match="create">
    <ProjectEdit editCallback="{ updateProject }"/>
</Route>
<Route match="edit" let:router>
    <ProjectEdit editCallback="{ updateProject }" project_id="{ router.id }"/>
</Route>
